import LoginForm from './LoginForm'

export default LoginForm



// WEBPACK FOOTER //
// ./src/views/Secure/components/LoginForm/index.js